import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { colors, fonts, useMediaQuery } from "../Styles";
import { NewInput, NewSelect } from "../Components";
import { NewFieldStyles, FieldStyles } from ".";
import { ValueType } from "./valueTypes";

/* eslint-disable */
export enum ActionDisplayEnum {
  select = "select",
  input = "input",
  date = "date",
  costum = "costum"
}
/* eslint-enable */

export interface ActionField {
  id?: number,
  value?: ValueType
}

export interface ActionDisplayType {
  id: number,
  label: string,
  displayType?: ActionDisplayEnum,
  options?: {
    label: string,
    id: number
  }[],
  text?: string
}

export const ActionContent = (props: {filter: ActionField, index?: number, filterParameterTypes?: ActionDisplayType[], handleFilterValueChange: (value: any) => void, costumContent?: JSX.Element, operationsView?: boolean }) => { 
  const {t} = useTranslation()
  const [thisDate, setThisDate] = useState<Date>(new Date());
  const [field, setField] = useState<ActionField>();
  const {filter, filterParameterTypes, costumContent } = props;
  const filterParameter = filterParameterTypes?.find((filterParameterType) => filterParameterType.id === filter.id)
  const mobileXs = useMediaQuery(`(max-width: 793px)`);

  useEffect(() => {
    if (filter.value) {
      setField({ ...filter.value });
    } else {
      setField({ id: -1 });
    }
  }, [filter.value]);

  const handleFieldChange = (value: { id: number }) => {
    setField((prevField) => ({
      ...prevField,
      id: value.id
    }));
    props.handleFilterValueChange([value]);
  };

  // Delete field
  const handleFieldDelete = useCallback(() => {
    setField({ id: -1 });
  }, []);
  
  if (!filterParameter?.displayType) {
    return null
  }
  
  switch (filterParameter.displayType) {
    case ActionDisplayEnum.select:
      return (
        <div style={{boxSizing: "border-box"}}>
          {field && field.id ?
            <div key={field.id !== undefined ? `${field.id}` : "initial"}>
              <NewSelect
                header={t("to", {defaultValue: "to"})}
                placeholder={t("select", {defaultValue: "select"})}
                options={filterParameter.options || []}
                onChange={(option) => { 
                  if (option) handleFieldChange({ id: Number(option.id) });
                }}
                isClearable={field.id !== -1}
                onClear={() => handleFieldDelete()}
                fieldOverrides={{
                  fieldStyle: props.operationsView ? NewFieldStyles.greyDarkPrimary : NewFieldStyles.blueDarkSecondary,
                  fieldWidth: mobileXs&&!props.operationsView ? "290px" : mobileXs&&props.operationsView ? "100%" : "280px"
                }}
                valueOverrides={{
                  defaultValue: filterParameter.options?.find((option) => option.id === field?.id) || undefined
                }}
              />
            </div>
          : <></>}
        </div>
      )
    case ActionDisplayEnum.input:
      return (
        <div style={{}}>
          {/* {fields.map((field, fieldIndex) => (
            <div key={field.id !== undefined ? `${field.id}-${fieldIndex}` : fieldIndex} >
              <NewInput
                placeholder={"0..."} 
                key={fieldIndex+String(field.id)}
                fieldOverrides={{
                  fieldStyle: NewFieldStyles.greyTertiary,
                  fieldWidth: "137.5px"
                }}
                valueOverrides={{
                  valueType: "number"
                }}
              />
            </div>
          ))} */}
        </div>
      );
    case ActionDisplayEnum.date: // Location
      return <div style={{boxSizing: "border-box"}}>
        {/* <DateField value={thisDate} onChange={({ date }) => setThisDate(date)} fieldStyle={FieldStyles.greyTertiary} textStart/> */}
      </div>
    case ActionDisplayEnum.costum: // Location
      return <div style={{boxSizing: "border-box"}}>
        {costumContent || <div>No custom content available</div>}
      </div>
    default:
    return null;
  }
};